<div class="card">
    <div class="card-body">
        <h4 class="card-title">Pruebas pendientes</h4>
        
        <div class="m-t-40">
                <div class="d-flex">
                
                    <div class="ml-auto">
                        <div class="form-group">
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table class="table table-bordered table-hover toggle-circle " >
                    <thead>
                        <tr>
                            <th> Prueba</th>
                            <th >De</th>
                            <th >Fecha de creación</th>
                            <th class="text-center" >Realizar</th>
                        </tr>
                    </thead>
                    
                    <tbody *ngIf="tests.length>0">
                        <tr *ngFor="let test of tests">
                            <td *ngIf="!test.isCompleted" class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{test.type=='FORMULARIO'?'Formulario a completar':test.type}} <span *ngIf="test.camera" class="text-danger pull-right">Requiere cámara</span></td>
                            <td *ngIf="!test.isCompleted" class="footable-visible">{{test.clientName}}</td>
                            <td *ngIf="!test.isCompleted" class="footable-visible">{{test.createDate | date:'mediumDate'}}</td>
                            <td *ngIf="!test.isCompleted" class="footable-visible footable-last-column text-center">
                                <button *ngIf="!test.isStarted" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="execute(test)" ><i class="fa fa-book" aria-hidden="true"></i></button>
                                <span *ngIf="test.isStarted" class="text-danger">Prueba bloqueada</span>  
                            </td>
                        </tr>
                    </tbody>
             
                </table>

            </div>
    </div>
</div>
<app-camera *ngIf="testData && testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<div id="formModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel"><b>Por favor, complete el siguiente formulario</b></h4>
            </div>
            <div class="modal-body pl-3 pr-3 pb-3 pt-0">
              <div class="row">
                <div *ngIf="formWelcome" class="col-12 p-3 text-break">
                  <p><b>{{testData.completeForm.successMessage}}</b></p>
                  <button class="btn btn-info btn-sm waves-effect btn-rounded pull-right mt-3" (click)="formWelcome = false; formStarted = true; startForm()">Comenzar</button>
                  <button class="btn btn-warning btn-sm waves-effect btn-rounded pull-right mt-3 mx-2" (click)="reload()">Cancelar</button>
                </div>
                <div *ngIf="formEnded" class="col-12 p-3 text-break">
                  <p><b>{{testData.completeForm.failMessage}}</b></p>
                </div>
              </div>
                <div *ngIf="testData && formStarted" class="row justify-content center">
                    <div *ngFor="let field of testData.formModel; index as i" class="col-12">
                        <div *ngIf="field.type=='text'||field.type=='number'" class="form-group mt-3">
                            <span class="text-black"><small><b>{{field.text}}</b></small></span>
                            <input autocomplete="off" [(ngModel)]="formModel[i]" [type]="field.type"  class="form-control" [placeholder]="" >
                        </div>
                        <div *ngIf="field.type == 'radio' || field.type == 'multiple'" class="demo-radio-button mt-3">
                            <span class="text-black"><small><b>{{field.text}}</b></small></span>
                            <div class="row px-3">
                                <div class='option col-12'*ngFor="let opt of field.data; index as j" (click)="toggleSelectedOption(i, opt.text, field.type == 'multiple' ? true : false)" >
                                  <img [src]="isSelected(i, opt.text) ? '/assets/images/icon/check.png' : '/assets/images/icon/uncheck.png'" alt=""><small><b>{{opt.text}}</b></small>
                                  <!-- <input id="enum_answer_{{i}}{{j}}" [value]='opt.text' type="radio" name="enums_{{i}}" [(ngModel)]="formModel[i]" >
                                  <label for="enum_answer_{{i}}{{j}}">
                                      {{opt.text}}
                                  </label> -->
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="col-12">
                        
                        <button class="btn btn-info btn-sm waves-effect btn-rounded pull-right mt-3" (click)="sendForm()">Continuar</button>
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="formMessageModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-body p-3">
              <div class="text-break" *ngIf="formModalMessage">
                <p><b>{{formModalMessage}}</b></p>
              </div>
              <button class="btn btn-info waves-effect btn-rounded pull-right" data-dismiss="modal">Aceptar</button>
          </div>
      </div>
  </div>
</div>